// Skeleton primitive
const Bone = ({ className = "" }) => <div className={`animate-pulse rounded-md bg-background-tertiary ${className}`} />;

// Mirrors CandidateProfilePanel's real layout so there's no jump on load.
const CandidateProfilePanelSkeleton = () => {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      {/* Header */}
      <div className="relative shrink-0 bg-background-secondary border-b border-border-primary px-5 pb-6 pt-6">
        <div className="flex flex-col items-center gap-2">
          <Bone className="h-6 w-40" />
          <Bone className="h-4 w-32" />
          <Bone className="h-3 w-24 mt-1" />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto custom-scrollbar">
        {/* Contact */}
        <div className="shrink-0 px-3 pt-4 pb-3">
          <Bone className="h-3.5 w-16 mb-2.5" />
          <div className="flex flex-col gap-2">
            <Bone className="h-6 w-3/4" />
            <Bone className="h-6 w-1/2" />
          </div>
        </div>
        <div className="mx-4 border-t border-border-primary" />

        {/* Social */}
        <div className="shrink-0 px-4 pt-3 pb-3">
          <Bone className="h-3.5 w-14 mb-2" />
          <div className="flex gap-1.5">
            <Bone className="h-8 w-8 rounded-lg" />
            <Bone className="h-8 w-8 rounded-lg" />
            <Bone className="h-8 w-8 rounded-lg" />
          </div>
        </div>
        <div className="mx-4 border-t border-border-primary" />

        {/* Stats */}
        <div className="shrink-0 px-2 pt-4 pb-3">
          <div className="grid grid-cols-2 gap-2">
            <Bone className="h-20 rounded-xl" />
            <Bone className="h-20 rounded-xl" />
            <Bone className="h-20 rounded-xl" />
            <Bone className="h-20 rounded-xl" />
          </div>
        </div>
        <div className="mx-4 border-t border-border-primary" />

        {/* Summary */}
        <div className="shrink-0 px-4 pt-4 pb-5">
          <Bone className="h-3.5 w-20 mb-2.5" />
          <div className="flex flex-col gap-2">
            <Bone className="h-3 w-full" />
            <Bone className="h-3 w-full" />
            <Bone className="h-3 w-5/6" />
            <Bone className="h-3 w-2/3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateProfilePanelSkeleton;
